import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=653d975f&scoped=true"
import script from "./Button.vue?vue&type=script&setup=true&lang=ts"
export * from "./Button.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Button.vue?vue&type=style&index=0&id=653d975f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653d975f",
  null
  
)

export default component.exports